"use client"

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"
import { Badge } from "@/components/ui/badge"
import { format } from "date-fns"

// Assuming the 'appointments' prop matches the structure from the API
// { id, appointment_date, status, doctors: { name, specialization } }
interface Appointment {
  id: string;
  appointment_date: string;
  status: string;
  appointment_type: string;
  doctors: {
    name: string;
    specialization: string | null;
  } | null;
}

interface AppointmentsHistoryTabProps {
  appointments: Appointment[];
}

export function AppointmentsHistoryTab({ appointments }: AppointmentsHistoryTabProps) {
  if (!appointments || appointments.length === 0) {
    return <p className="text-center text-muted-foreground mt-4">No appointment history found.</p>
  }
  
  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Doctor</TableHead>
            <TableHead>Type</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {appointments.map((appt) => (
            <TableRow key={appt.id}>
              <TableCell>{format(new Date(appt.appointment_date), "PPP")}</TableCell>
              <TableCell>
                <div className="font-medium">{appt.doctors?.name || "N/A"}</div>
                <div className="text-sm text-muted-foreground">{appt.doctors?.specialization || ""}</div>
              </TableCell>
              <TableCell>
                <Badge variant="outline">{appt.appointment_type || "Regular"}</Badge>
              </TableCell>
              <TableCell>
                 <Badge variant={appt.status === 'completed' ? 'default' : appt.status === 'cancelled' ? 'destructive' : 'secondary'}>
                    {appt.status}
                </Badge>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
} 